function SetDateForInputDate(date: any, isActiveDay = true) {
  let output: any = "";
  const dateStr = date;
  let dateArray = [];
  let yearFirstDateArray = [];
  const slash = dateStr.includes("/");
  const minus = dateStr.includes("-");
  if (slash) {
    dateArray = dateStr.split("/");
    yearFirstDateArray = dateStr.split("/");
  } else if (minus) {
    dateArray = dateStr.split("-");
    yearFirstDateArray = dateStr.split("-");
  } else if (dateStr.length <= 8) {
    if (isActiveDay) {
      dateArray.push(dateStr.substr(0, 2));
      dateArray.push(dateStr.substr(2, 2));
      dateArray.push(dateStr.substr(4, 4));

      yearFirstDateArray.push(dateStr.substr(0, 4));
      yearFirstDateArray.push(dateStr.substr(4, 2));
      yearFirstDateArray.push(dateStr.substr(6, 2));
    } else {
      dateArray.push(dateStr.substr(0, 2));
      dateArray.push(dateStr.substr(2, 4));

      yearFirstDateArray.push(dateStr.substr(0, 4));
      yearFirstDateArray.push(dateStr.substr(4, 2));
    }
  } else {
    dateArray = [];
  }
  let day, month, year;
  if (
    yearFirstDateArray.length > 1 &&
    parseInt(yearFirstDateArray[1]) <= 12 &&
    parseInt(yearFirstDateArray[0]) > 1700
  ) {
    if (isActiveDay) {
      day = parseInt(yearFirstDateArray[2]);
      month = parseInt(yearFirstDateArray[1]);
    } else {
      day = 1;
      month = parseInt(yearFirstDateArray[1]);
    }
    year = parseInt(yearFirstDateArray[0]);
    if (year > 2500) {
      year = year - 543;
    }
    const getDaysInMonth = new Date(year, month, 0).getDate();
    if (day <= getDaysInMonth) {
      output = new Date(year, month - 1, day);
    } else {
      output = "";
    }
  }
  if (dateArray.length > 1 && output === "") {
    if (isActiveDay) {
      day = parseInt(dateArray[0]);
      month = parseInt(dateArray[1]);
    } else {
      day = 1;
      month = parseInt(dateArray[0]);
    }
    if (month <= 12) {
      if (isActiveDay && dateArray[2]) {
        year = parseInt(dateArray[2]);
        if (year > 2500) {
          year = year - 543;
        }
      } else if (!isActiveDay && dateArray[1]) {
        year = parseInt(dateArray[1]);
        if (year > 2500) {
          year = year - 543;
        }
      } else {
        year = new Date().getFullYear();
      }
      const getDaysInMonth = new Date(year, month, 0).getDate();
      if (day <= getDaysInMonth) {
        output = new Date(year, month - 1, day);
      } else {
        output = "";
      }
    } else {
      output = "";
    }
  }
  return output;
}

export function GetDateJsonString(startDate: any) {
  if (startDate) {
    const outputDate = SetDateForInputDate(startDate.toString());

    if (outputDate) {
      return outputDate.ToDateJsonString();
    } else {
      return "";
    }
  } else {
    return "";
  }
}

export function SelectedAssetTemplate(_selectedTransactionItem: any, item: any) {
  const selectedTransactionItem = _selectedTransactionItem;
  if (item) {
    selectedTransactionItem.assetTemplate.value.code = item.code;
    selectedTransactionItem.assetTemplate.value.id = item.id;
    selectedTransactionItem.assetTemplate.value.nameTh = item.nameTh;
    selectedTransactionItem.assetTemplate.value.nameEn = item.nameEn;
    selectedTransactionItem.assetTemplate.value.accountScrapAmount = item.accountScrapAmount;
    selectedTransactionItem.assetTemplate.value.accountScrapTypeId = item.accountScrapTypeId;
    selectedTransactionItem.assetTemplate.value.accountScrapVal = item.accountScrapVal;
    selectedTransactionItem.assetTemplate.value.accountValPurchase = item.accountValPurchase;
    selectedTransactionItem.assetTemplate.value.accountValPurchaseAmount = item.accountValPurchaseAmount;
    selectedTransactionItem.assetTemplate.value.accountValPurchaseTypeId = item.accountValPurchaseTypeId;
    selectedTransactionItem.assetTemplate.value.accountDepreciationMethodId = item.accountDepreciationMethodId;
  } else {
    selectedTransactionItem.assetTemplate.value.code = "";
    selectedTransactionItem.assetTemplate.value.id = 0;
    selectedTransactionItem.assetTemplate.value.nameTh = "";
    selectedTransactionItem.assetTemplate.value.nameEn = "";
    selectedTransactionItem.assetTemplate.value.accountScrapAmount = 0;
    selectedTransactionItem.assetTemplate.value.accountScrapTypeId = 0;
    selectedTransactionItem.assetTemplate.value.accountScrapVal = 0;
    selectedTransactionItem.assetTemplate.value.accountValPurchase = 0;
    selectedTransactionItem.assetTemplate.value.accountValPurchaseAmount = 0;
    selectedTransactionItem.assetTemplate.value.accountValPurchaseTypeId = 0;
    selectedTransactionItem.assetTemplate.value.accountDepreciationMethodId = 0;
  }

  return selectedTransactionItem;
}

export function GetExcelDateTime(excelDate: any) {
  let output: any = "";
  if (
    !isNaN(new Date(excelDate).getTime()) &&
    new Date(excelDate).ToDateJsonString() != new Date("1970-01-01").ToDateJsonString()
  ) {
    output = new Date(excelDate);
  } else {
    const dt = new Date(1900, 0, 0);
    dt.setDate(dt.getDate() - 1 + excelDate);
    output = !isNaN(dt.getTime()) ? dt : new Date().ToDateJsonString();
  }
  return output;
}
